function addUrl(fd, url) {
  if (url == null || url === '') return
  fd.append('__rpcname', url)
}

function addPayload(fd, obj) {
  if (obj == null) return
  Object.keys(obj).forEach(k => {
    const value = obj[k]
    if (value != null) {
      fd.append(k, value)
    }
  })
}

export function useFd(url, payload) {
  if (payload instanceof FormData) {
    addUrl(payload, url)
    return payload
  }
  const fd = new FormData()
  addUrl(fd, url)
  addPayload(fd, payload)
  return fd
}



// WEBPACK FOOTER //
// ./src/utils/formData.js